import React from 'react';
import getName from '../../../../helpers/getName';

const RequestChangeContent = ({
  values,
  request,
  workersOld,
  executersOld,
  workers,
  executers,
  parentServices,
  services,
  oldServices,
  parentServicesOld,
}) => {
  const getValue = (data = [], value) => {
    if (!data || !value) return;

    return data?.find((e) => e.id === Number(value));
  };
  const executer = getValue(executers, values?.executerId);
  const oldExecuter = getValue(executersOld, request?.executer?.id);
  const worker = getValue(workers, values?.masterId);
  const oldWorker = getValue(workersOld, request?.master?.id);
  const oldParentService = getValue(
    parentServicesOld,
    request?.parentServiceId
  );
  const parentService = getValue(parentServices, values.parentServiceId);
  const oldService = getValue(oldServices, request?.serviceId);
  const service = getValue(services, values.serviceId);

  return (
    <div>
      <div>В связи с изменением услуги/причины</div>
      <div>
        с <strong>{`"${oldParentService?.name}/${oldService?.name}"`}</strong>
      </div>
      <div>
        на <strong>{`"${parentService?.name}/${service?.name}"`}</strong>
      </div>
      <div>будут изменены следующие данные:</div>
      <div style={{ marginTop: 15 }}>
        {Number(values?.executerId) !== Number(request?.executer?.id) && (
          <div>
            Исполнитель <strong>{getName(oldExecuter)}</strong> на{' '}
            <strong>{getName(executer)}</strong>
          </div>
        )}
        {Number(values?.masterId) !== Number(request?.master?.id) && (
          <div>
            Мастер <strong>{getName(oldWorker)}</strong> на{' '}
            <strong>{getName(worker)}</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestChangeContent;
